import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from "@angular/core";
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withViewTransitions } from "@angular/router";
import { HttpBackend, HttpClient, HttpXhrBackend, provideHttpClient, withInterceptors } from "@angular/common/http";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { routes } from "./app.routes";
import { icons, LucideAngularModule } from "lucide-angular";
import { accessKeyHeaderInterceptor } from "@core/interceptors/access-key-header.interceptor";
import { baseUrlInterceptor } from "@core/interceptors/base-url.interceptor";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideNgxStripe } from "ngx-stripe";
import { NeocomService } from "@shared/services/neocom.service";
import { environment } from "@environments/environment";

function HttpLoaderFactory(handler: HttpBackend): TranslateHttpLoader {
  const http = new HttpClient(handler);
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withViewTransitions(),
      withInMemoryScrolling({
        anchorScrolling: "enabled",
        get scrollPositionRestoration() {
          const params = new URLSearchParams(window.location.search);
          if (params.get("category") && params.get("filters")) {
            return "disabled" as const;
          }
          return "enabled" as const;
        },
      }),
    ),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([accessKeyHeaderInterceptor, baseUrlInterceptor])),
    importProvidersFrom(
      LucideAngularModule.pick(icons),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpXhrBackend],
        },
        defaultLanguage: "de",
      }),
    ),
    provideNgxStripe(environment.stripePubKey),
    provideAppInitializer((): void => {
      inject(NeocomService);
    }),
  ],
};
